import InsertMember from '@/gql/InsertMember.gql';
import UpdateMember from '@/gql/UpdateMember.gql';
import UpdateMemberCompany from '@/gql/UpdateMemberCompany.gql';
import $apolloClient from '@/services/apollo';

let member = null;
const update = {
  score: 0,
  profile: {},
  opportunities: {},
  completedAt: null,
};

function track(action, label, value) {
  const category = window.location.hostname === 'localhost' ? 'Developer' : 'Version1';
  console.log('Track', category, action, label);
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
  });
}

async function create(data) {
  track('Registered');
  const user = await $apolloClient.mutate({
    mutation: InsertMember,
    variables: data,
  });
  member = user.data.insert_Member.returning[0];
}

async function updateCompanyInfo(data) {
  let domain = null;
  if (data.companyWebsite) {
    domain = data.companyWebsite.replace('http://', '').replace('https://', '').replace('www.', '').trim();
  }
  await $apolloClient.mutate({
    mutation: UpdateMemberCompany,
    variables: {
      id: member.id,
      companyName: data.companyName,
      companyWebsite: data.companyWebsite,
      domain,
    },
  });
  console.log('Updated Company Info');
}

async function saveAnswer(question, answer) {
  update.profile[question.id] = {
    question: question.title,
    answer: answer.value,
  };
  if (answer.opportunity) {
    update.opportunities[answer.opportunity] = true;
    track('Opportunity', answer.opportunity);
  }
  update.score += (answer.score || 0);
  update.id = member.id;
  track('Answered', question.title);
  await $apolloClient.mutate({
    mutation: UpdateMember,
    variables: update,
  });
}

async function markComplete() {
  update.id = member.id;
  update.completedAt = new Date();
  track('Completed');
  await $apolloClient.mutate({
    mutation: UpdateMember,
    variables: update,
  });
}

function getMember() {
  return member;
}

track('Landed');

export default {
  create,
  saveAnswer,
  markComplete,
  getMember,
  updateCompanyInfo,
};
